export default __webpack_public_path__ + "static/media/hms-3.4f1acabb.jpeg";